<template>
	<div class="new-detail">
		<HeaderBar></HeaderBar>
		<section>
			<div class="container">
				<!-- <b-dropdown text="公司动态" variant="outline-primary" class="mt-4 mb-4">
					<b-dropdown-item href="#">公司新闻</b-dropdown-item>
					<b-dropdown-item href="#">政策导向</b-dropdown-item>
				</b-dropdown> -->
				<div class="row detail mt-4">
					<div class="col-lg-12">
						<div class="title">
							{{ article.post_title }}
						</div>
						<div class="time">
							更新时间：{{ article.update_time }} 作者：{{ article.user_login }}
						</div>
						<div v-html="article.post_content"></div>
					</div>
				</div>
			</div>
		</section>
		<FooterBar></FooterBar>
	</div>
</template>

<script>
import HeaderBar from '@/components/header-bar';
import FooterBar from '@/components/footer-bar';
import { baseUrl } from '../../config/config';
export default {
	name: 'newlist',
	components: {
		HeaderBar,
		FooterBar,
	},
	data() {
		return {
			id: this.$route.query.id,
			article: {}, //文章详情
		};
	},
	computed: {},
	mounted() {
		this.getDetail();
	},
	methods: {
		//获取文章详情
		getDetail() {
			let params = { do: 'detail', id: this.id };
			this.$axios
				.post(baseUrl + '/portal/Article/index', params)
				.then((res) => {
					if (res.data.code === 1) {
						this.article = res.data.data.article;
					}
				});
		},
	},
};
</script>
<style lang="scss">
.new-detail {
	.detail {
		.title {
			text-align: center;
			font-size: 1.8rem;
			margin-bottom: 1rem;
		}
		.time {
			text-align: center;
			margin-bottom: 1rem;
			color: #888;
			font-size: 0.8rem;
		}
		.content {
			margin-bottom: 2rem;
		}
	}
}
</style>
